export const Header = {
  title: 'Mulai Investasi Emas dengan Mudah & Murah, Mulai dari Rp15 Ribu!',
  subtitle:
    '12jt+ orang telah merasakan mudah dan murahnya investasi emas di BukaEmas, tanpa perlu antri dan bisa transaksi kapan saja mulai dari Rp15 Ribu!',
  tryNow: 'Nabung Sekarang',
  learnMore: 'Pelajari lebih lanjut',
};

export const Benefits = {
  title: 'Keuntungan Menabung di BukaEmas',
  items: [
    {
      image: 'icons/img_small_gold.png',
      title: 'Jual & Beli mulai dari Rp15 Ribu',
      subtitle:
        'Kamu dapat membeli dan menjual emas mulai dari Rp15 Ribu, yang sangat terjangkau untuk mulai investasi emas kamu bila dibandingkan dengan jual beli emas pada umumnya',
    },
    {
      image: 'icons/img_small_calendar.png',
      title: 'Transaksi Emas 24/7',
      subtitle:
        'Kamu bisa melakukan transaksi jual beli emas kapan saja dan dimana saja tanpa perlu ribet-ribet antri, dengan harga yang selalu update setiap saat',
    },
    {
      image: 'icons/img_small_success.png',
      title: 'Bisa diakses menggunakan akun Bukalapak dan BMoney',
      subtitle:
        'Kamu bisa merasakan kemudahan investasi emas dari dua platform, lewat Bukalapak dan BMoney yang menawarkan opsi diversifikasi aset investasi kamu',
    },
  ],
};

export const Features = {
  title: 'Apa Saja yang Dapat Dilakukan di BukaEmas?',
  items: [
    {
      image: 'landing/beli_emas.png',
      title: 'Beli Emas Online',
      subtitle: 'Cukup masukan gram atau nominal emas yang kamu beli mulai dari Rp15 Ribu',
    },
    {
      image: 'landing/simpan_emas.png',
      title: 'Simpan Emas',
      subtitle:
        'Tabungan Emas kamu disimpan di tempat penyimpanan emas Treasury yang sudah mendapatkan izin penyimpanan emas dari Otoritas Jasa Keuangan (OJK). Kamu tetap dapat menjualnya kapan saja.',
    },
    {
      image: 'landing/jual_emas.png',
      title: 'Jual Emas Online',
      subtitle:
        'Kamu bisa jual saldo emas kamu mulai dari Rp15 Ribu. Lewat BukaEmas, rasakan kemudahan menjual saldo emas kamu kapan saja dan dimana saja.',
    },
  ],
};

export const Articles = {
  title: 'Artikel',
  items: [
    {
      title: 'Selain Low Risk, Inilah 5 Keuntungan Investasi Emas',
      url: 'https://review.bukalapak.com/finance/keuntungan-investasi-emas-1503',
      image: 'landing/keuntungan-investasi-emas-small.jpg',
      excerpt:
        'Salah satu hal yang paling ditakutkan saat memutuskan untuk berinvestasi adalah risiko-risiko yang akan didapat bukan?',
    },
    {
      title: '6 Alasan Investasi Emas Online Lebih Murah dan Aman',
      url: 'https://review.bukalapak.com/finance/6-alasan-investasi-emas-online-lebih-murah-dan-aman-1434',
      image: 'landing/piggy-gold-small.jpg',
      excerpt:
        'Dengan kenaikan mencapai 20-40 persen per tahun, emas menjadi alat investasi yang menggiurkan. Emas memang cocok untuk ...',
    },
    {
      title: '8 Bukti Investasi Emas Enggak Membutuhkan Modal Awal ...',
      url: 'https://review.bukalapak.com/finance/8-bukti-investasi-emas-enggak-membutuhkan-modal-awal-yang-besar-1431',
      image: 'landing/gold-is-money-small.jpg',
      excerpt:
        'Punya pikiran kalau investasi emas itu butuh modal besar dan hanya untuk kalangan atas? Dengan investasi emas secara online ...',
    },
    {
      title: 'Investasi Emas Sekarang, Menikah Tanpa Merepotkan',
      url: 'https://review.bukalapak.com/finance/investasi-emas-sekarang-menikah-tanpa-merepotkan-orang-tua-kemudian-1428',
      image: 'landing/bridal-emas-small.jpg',
      excerpt: 'Punya dream wedding yang selama ini mengganggu tidur dan selalu jadi topik pembicaraan bersama?',
    },
    {
      title: 'Ini Keuntungan dan Cara Mudah Investasi Emas di Usia Muda',
      url: 'https://review.bukalapak.com/finance/ini-keuntungan-dan-cara-mudah-investasi-emas-di-usia-muda-1422',
      image: 'landing/money-emas-small.jpg',
      excerpt:
        'Jadi kaya di usia muda? Bukan hal yang tidak mungkin. Asal tahu cara mengelola keuangan. Salah satunya investasi emas.',
    },
  ],
};

export const StartTransaction = 'Mulai Transaksi Emas';
